import { useQuery } from '@tanstack/react-query';
import { generateSiteLockspaceSearchKey } from 'src/api/lib/meilisearch';
import { siteMeilisearchLockspaceSearchKeyKeys } from 'src/api/query-keys/site/meilisearch-lockspace-search-key';
import { useUserStore } from 'src/store/user-store';

export const useGenerateSiteLockspaceSearchKey = (enabled = true) => {
  const { directoryTokenLockspace } = useUserStore();

  return useQuery({
    queryFn: generateSiteLockspaceSearchKey,
    queryKey: siteMeilisearchLockspaceSearchKeyKeys.detail(
      directoryTokenLockspace ?? '',
    ),
    enabled: enabled && !!directoryTokenLockspace,
  });
};
